import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoursesService } from 'src/app/services/courses.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-start-course-modal',
  templateUrl: './start-course-modal.component.html',
  styleUrls: ['./start-course-modal.component.scss']
})

export class StartCourseModalComponent implements OnInit {

  faTimes = faTimes;
  @Input() selfModal: NgbModalRef | null = null;
  @Input() courseName: string = '';
  @Input() courseId: string = '';
  loadSpin: boolean = false;
  faCircleNorch: any = faCircleNotch;

  constructor(
    public activeModal: NgbActiveModal,
    private coursesService: CoursesService,
    private toastService: ToastService,
    private router: Router,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
  }

  closeModal() {
    if (this.selfModal) this.selfModal?.close();
    else $("ngb-modal-window").click();
  }

  confirmStart() {
    this.loadSpin = true;
    this.coursesService
      .startCourse(this.courseId)
      .then((res) => {
        this.loadSpin = false;
        if (res.result == 'success') {
          this.toastService.showSuccess(
            this.translateService.instant('courses:start:success')
          );

          const cleanUrl = this.router.url.split('?')[0];
          window.location.href = cleanUrl;
       //   this.activeModal.close('confirmed');
        }
        if (res.error) {
          this.toastService.showError(
            this.translateService.instant(res.error.message.friendly)
          );
        }
      })
      .catch((err) => {
        this.loadSpin = false;
        this.toastService.showError(
          this.translateService.instant('courses:start:error')
        );
      });
  }

}
